module.exports = __webpack_public_path__ + "static/media/logo.c852fc4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 177
// module chunks = 0